<template>
  <div class="pages">
    <tab @tabChange="initContent" :list="list">
      <div slot="current">
        <p class="tips">*开车前30分钟不能预约</p>
        <div class="main">
          <div class="item">
            <div class="tops">
              <span class="destination">公司 - 火车站</span>
              <van-button
                plain
                type="info"
                size="small"
                class="commonColor btns"
                >预约</van-button
              >
            </div>
            <div style="margin-top: 20px" class="lists">
              <p>发车时间：2012-10-14</p>
              <p>已预约人数：46人</p>
            </div>
          </div>
          <div class="item">
            <div class="tops">
              <span class="destination">公司 - 火车站</span>
              <van-button
                plain
                type="info"
                size="small"
                class="commonColor btns"
                >预约</van-button
              >
            </div>
            <div style="margin-top: 20px" class="lists">
              <p>发车时间：2012-10-14</p>
              <p>已预约人数：46人</p>
            </div>
          </div>
        </div>
      </div>
      <div slot="history">
        <div class="main" style="margin-top: 20px">
          <div class="item">
            <div class="tops">
              <span class="destination">公司 - 火车站</span>
              <van-button
                plain
                type="info"
                size="small"
                class="commonColor btns"
                >取消</van-button
              >
            </div>
            <div class="autoFlex" style="margin-top: 20px">
              <div class="lists">
                <p style="margin-bottom: 20px">发车时间：2012-10-14</p>
                <p>已预约人数：46人</p>
              </div>
              <img src="../assets/sushe/yuyuezhong.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </tab>
  </div>
</template>
<script>
import tab from "../components/tabs.vue";
export default {
  data() {
    return {
      list: [
        {
          name: "当前预约",
          type: "current",
        },
        {
          name: "历史预约",
          type: "history",
        },
      ],
    };
  },
  mounted() {
    document.title = "坐车预约";
  },
  methods: {
    initContent(value) {
      // console.log(value)
    },
  },
  components: {
    tab,
  },
};
</script>
<style scoped lang='less'>
@import url("../style/common.css");
.tips {
  color: #be8100;
  font-size: 24px;
  padding: 10px 20px;
}
.lists {
  p {
    margin-bottom: 10px;
  }
}
img {
  width: 150px;
  height: 130px;
}
.pages {
  background: #f7f7f7;
  min-height: 100vh;
  .main {
    padding: 0 20px;
    .item {
      background: #fff;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 10px;
      margin-bottom: 20px;
      .tops {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #ececec;
        padding-bottom: 20px;
        .btns {
          width: 94px;
          height: 40px;
          span {
            font-size: 24px !important;
          }
        }
        .destination {
          font-size: 32px !important;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
